import { FlatRoomsContainer } from '../../containers/advancedFilters/FlatRoomsContainer';
import { IFilter } from '../../types/filters';

export const flatRooms: IFilter = {
  component: FlatRoomsContainer,
};
